import { gql } from '@apollo/client';

const CouponValidateMutation = gql`
  mutation CouponValidation($input: CouponValidateInput!) {
    couponValidate(input: $input) {
      valid
      errorMessage
    }
  }
`;

export default CouponValidateMutation;